module.exports = __webpack_public_path__ + "ac42355d114d789b0e74dcc2a589aa1b.MP3";